import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import appReducer from './reducers/app';
const rootReducer = combineReducers({
  app: appReducer,
});

let enhancer;
if (process.env.NODE_ENV === 'development') {
  enhancer = compose(
    applyMiddleware(thunk)
  );

} else {
  enhancer = compose(applyMiddleware(thunk));
}

const store: any = createStore(rootReducer, {}, enhancer);

if (process.env.NODE_ENV === 'development') {
  if (typeof window !== "undefined") {
    window.store = store;
  }
}

export { store };
